import { Avatar, Box, Button, Typography } from "@mui/material";
import { colors } from "../../../common/colors";
import GCBackButton from "../../../components/GreenCity/GCBackButton";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import { ErrorMessageModal } from "../../../components/ErrorMessageModal";
import SubmitButton from '../../../components/SubmitButton';
import appServices from "../../../services/app-services/appServices";

const PaymentReview = () => {
  const navigate = useNavigate();
  const groupInfo = useSelector((state: any) => state.gcGroup);
  const payment = useLocation().state.payment;
  const shopInfo = useLocation().state.shopInfo;
  const [message, setMessage] = useState<string>("");
  const [alignLeft, setAlignLeft] = useState<boolean>(false);
  const [openErrorMessageModal, setOpenErrorMessageModal] = useState<boolean>(false)
  const [success, setSuccess] = useState<boolean>(false);
  const [group, setGroup] = useState<any>();

  const onSubmit = async () => {
    try {
      const body = {
        payer_id: groupInfo.id,
        payee_id: shopInfo?.external_id,
        amount: payment,
        payer_type: "MemberGroup",
        payee_type: "Shop",
        payment_type: "StorePayment",
        billing_cycle: "one_time",
      }
      await appServices.createPayment(body)
      setSuccess(true);
      return true
    } catch(error: any) {
      setSuccess(false);
      setMessage(error.response.data.message.join("\n"));
      setAlignLeft(true)
      setOpenErrorMessageModal(true)
      return false
    }
  };

  const goBack = () => {
    if (success) {
      navigate("/groupleader", { state: { groupId: group.id }});
    } else {
      navigate(-1)
    }
  }

  useEffect(() => {
    appServices.getMembersGroup(groupInfo.id).then((res) => {
      setGroup(res.member_group);
    }).catch((error) => {});
  }, [])

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <Box sx={styles.headerBox}>
        <GCBackButton onClick={() => goBack()} />
        <Box sx={styles.rowMargin}>
          <Avatar
            src={groupInfo?.groupImage instanceof File ? URL.createObjectURL(groupInfo.groupImage) : ''}
            sx={{ ...styles.avatar, width: "30px" }}
          />
          <Typography>{groupInfo.groupName}</Typography>
        </Box>
      </Box>
      <Box sx={styles.container}>
        <Box sx={{ transform: success ? "rotate(0deg)" : "rotate(180deg)", marginTop: "20px" }}>
          <Typography sx={styles.title}>{shopInfo.name}</Typography>
          <Typography sx={{ ...styles.paymentInput, borderBottom: "2px solid " + colors.farm_black }}>¥{payment}</Typography>
        </Box>
        <Typography sx={{ ...styles.text, whiteSpace: "pre-line" }}>
          {success ? T("payment_review_paid") : T("payment_review_confirm_with_clerk")}
        </Typography>
        {success ? (
          <Box sx={styles.center}>
            <img src={require("../../../assets/images/success-payment.png")} style={{ width: "160px", height: "113px", margin: "20px" }} />
            <Button
              color="secondary"
              sx={{ ...styles.button, border: "2px solid " + colors.farm_blue200, background: "white" }}
              size={"large"}
              variant={"outlined"}
              onClick={() => navigate("/paymenthistory", { state: {groupId: groupInfo.id}})}
              endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faChevronRight} />}
            >
              {T("finish")}
            </Button>
          </Box>
        ) : (
          <Box sx={styles.center}>
            <SubmitButton
              color="secondary"
              sx={styles.button}
              disabled={!payment}
              size={"large"}
              variant={!payment ? "outlined" : "contained"}
              endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, right: 0, margin: "10px" }} icon={faChevronRight} />}
              validate={async () => true}
              onSubmit={onSubmit}
            >
              {T("pay")}
            </SubmitButton>
            <Button
              color="secondary"
              sx={{ ...styles.button, border: "2px solid " + colors.farm_blue200, background: "white" }}
              disabled={!payment}
              size={"large"}
              variant={"outlined"}
              onClick={() => goBack()}
              endIcon={<FontAwesomeIcon style={{ position: "absolute", top: 0, left: 0, margin: "10px" }} icon={faChevronLeft} />}
            >
              {T("payment_review_change_amount")}
            </Button>
          </Box>
        )}
      </Box>
      <ErrorMessageModal
        open={openErrorMessageModal}
        onClose={() => { setOpenErrorMessageModal(false) }}
        messages={[message]}
        alignLeft={alignLeft}
      />
    </Box>
  );
};

const styles = {
  headerBox: {
    padding: "1px 16px",
    paddingTop: "90px",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
  },
  avatar: {
    height: "30px",
    borderRadius: "50%",
    marginRight: "10px",
    objectFit: "cover",
    overFlow: "hidden",
    backgroundColor: "#E8E8E8",
  },

  container: {
    padding: "0px 20px",
    backgroundColor: colors.farm_gray50,
    flex: 1,
    display: "flex",
    flexDirection: "column",
  },
  title: {
    fontSize: 20,
    fontFamily: "mplus-1c-regular",
    fontWeight: "600",
    marginTop: "10px",
  },
  text: {
    fontSize: 16,
    textAlign: "center",
    fontFamily: "mplus-1c-regular",
    marginTop: "30px",
  },
  paymentInput: {
    color: colors.farm_blue200, // Change text color
    fontSize: "26px", // Change font size
    fontWeight: "600",
  },
  rowMargin: {
    display: "flex",
    alignItems: "center",
    margin: "10px",
  },
  button: {
    width: "80%",
    alignSelf: "center",
    display: "flex",
    borderRadius: 20,
    marginTop: "20px",
  },
  textInput: {
    width: "100%",
    backgroundColor: "white",
    marginTop: "10px",
  },
  center: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }
};
export default PaymentReview;
